// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2Jz9U","detailsBorder":"styles_detailsBorder__18Wft"};